<template>
  <div class="purchaseOverview projectOverview">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeContract="changeContract"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        rowKey="id"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title ? ($utils.hasChina(item.title) ? item.title : $t(item.title)) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ dictListMap[item.dictType].find((v) => v.value == scope.row[item.field])?.label }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.type == 'seq'">{{
              ($refs.siruiTable.page.pageNum - 1) * $refs.siruiTable.page.pageSize +
              scope.$rowIndex +
              1
            }}</span>
            <span v-else-if="item.field == 'isAutotrophy'">
              <span v-if="scope.row['isAutotrophy'] == '1'">是</span>
              <span v-if="scope.row['isAutotrophy'] == '0'">否</span>
            </span>
            <span v-else-if="item.field == 'isPackageDo'">
              <span v-if="scope.row['isPackageDo'] == '1'">是</span>
              <span v-if="scope.row['isPackageDo'] == '0'">否</span>
            </span>
            <span v-else-if="item.field == 'projectInitiationStatus'">
              {{ transformProjectInitiationStatus(scope.row[item.field]) }}
            </span>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="scope.row[item.field]"
                @click="goOaLink(scope.row[item.field])"
                >查看</a
              >
            </template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
    <ProjectFinishDialog
      v-model="dialogVisible"
      :id="projectFinishId"
      :isExecuted="isExecuted"
      @refresh="getData"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import ProjectApi from '@/api/purchaseSalesCenter/project.js';
  import BASE_API from '@/api/dataBase.js';
  import { filterEmpty, toLine } from '@/common/js/util';
  import ProjectFinishDialog from './components/projectFinishDialog.vue';
  import { formColumn, columnListDefault } from './projectOverview.js';
  export default {
    name: 'projectOverview',
    mixins: [tableMixins],
    components: {
      ProjectFinishDialog,
    },
    data() {
      return {
        footerTotalCols: {
          amount: ['winBidAmount', 'monthlySupply', 'operatingRevenueTarget'],
          quantity: ['productQuantity'],
        }, //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        query: {
          // 项目编号
          projectInitiationNo: null,
          projectInitiationCreateDateStart: null,
          projectInitiationCreateDateEnd: null,
          projectAbbreviation: null,
          operaterList: null,
          operaterNo: null,
          applyDepartmentNo: null,
          applyCompanyNo: null,
          chargePerson: null,
          chargePersonNo: null,
          projectNo: null,
          projectName: null,
          businessType: null,
          customer: null,
          customerNo: null,
          customerName: null,
          recyclingtCompanyList: [],
          platformtCompanyList: [],
          projectProvinceCode: null,
          projectCityCode: null,
          enterpriseType: null,
          projectUsageQuotaStart: null,
          projectUsageQuotaEnd: null,
          projectReceivableQuotaStart: null,
          projectReceivableQuotaEnd: null,
          projectIncomePointStart: null,
          projectIncomePointEnd: null,
          projectAccountingPeriodStart: null,
          projectAccountingPeriodEnd: null,
          operatingRevenueTargetStart: null,
          operatingRevenueTargetEnd: null,
          collectionCycleStart: null,
          collectionCycleEnd: null,
          monthlySupplyStart: null,
          monthlySupplyEnd: null,
          winBidAmountStart: null,
          winBidAmountEnd: null,
          receiptToAddress: null,
          subjectMatterList: null,
          paymentMethod: null,
          collectionCycle: null,
          warrantyClause: null,
          remark: null,
          winBidResult: null,
          winBidAmount: null,
          winBidContractNo: null,
          biddingManagementFee: null,
          biddingPackageMoneyMethod: null,
          specificReason: null,
          projectInitiationStatus: null,
          bidStatus: null,
          closeBeforeStatus: null,
          amountStart: null,
          amountEnd: null,
        },
        departmentList: [],
        companyList: [],
        //排序条件
        sortParams: null,
        columnListDefault,
        dialogVisible: false,
        projectFinishId: null,
        isExecuted: false, //选中行是否未已执行状态
        companyList1: [], // 回收公司和平台公司
        selectList: [], // 选中的行
        projectStatusList: [],
      };
    },
    computed: {
      action() {
        return API.IMPORT_ORDER_API;
      },
      searchColumns() {
        return formColumn(this);
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictListMap: (state) => state.dict.dictListMap,
      }),
    },
    mounted() {
      this.$nextTick(() => {
        this.getProjectStatusList();
        this.getButtonList();
        this.getCompany();
        this.getDepartment();
        this.getData();
        this._getCompanyApi1(this.userInfo.userInfo.tenantCode);
      });
    },
    methods: {
      // 获取项目状态字段
      async getProjectStatusList() {
        const { data } = await this.$axios.post(BASE_API.DIC_CREDIT_API, {
          dictType: 'PROJECT_INITIATION_STATUS',
        });
        if (data.code == 0) {
          this.projectStatusList = data.data;
        } else {
          this.projectStatusList = [];
        }
        console.log(data, '获取字典');
      },
      // 翻译项目状态
      transformProjectInitiationStatus(it) {
        return this.projectStatusList.find((item) => item.value == it)?.label;
      },
      handleSelectionChange(row) {
        this.selectList = row;
        this.multipleSelection = row;
      },
      // 回收公司和平台公司
      async _getCompanyApi1(tenantCode) {
        const { data } = await this.$axios.get(`${BASE_API.LISTDATA_SERECHCOMPANY}/${tenantCode}`);
        if (data.code == 0) {
          this.companyList1 = Object.freeze(data.data);
        } else {
          console.error('获取公司失败');
        }
      },
      //初始化数据
      getData() {
        //如果没有查询条件，提示信息
        let count = Object.keys(this.query).length;
        for (var key in this.$refs.siruiSearch.query) {
          if (
            this.$refs.siruiSearch.query[key] == null ||
            this.$refs.siruiSearch.query[key] == undefined ||
            this.$refs.siruiSearch.query[key] == ''
          ) {
            count = count - 1;
          }
        }
        let params = this.getQueryData();
        params = this.handleValueToNumber(params);
        //默认 制单日期倒叙
        params.searchOrderItems = this.sortParams;
        params.dataGroup = this.$globalVar.dataGroup;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        // params.applyCompanyNo = this.userInfo.userInfo.companyCode;
        // params.applyDepartmentNo = this.userInfo.userInfo.departmentCode;
        params.businessGroup = this.userInfo.userInfo.businessGroup;
        this.load = true;
        this.$axios.post(ProjectApi.PROJECT_List, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = Object.freeze(res.data.data.records);
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //处理查询数据
      getQueryData() {
        const query = Object.assign({}, this.$refs.siruiSearch.query);
        query.operaterNo = this.handleMultiple2Single(query.operaterList, 'personNo');
        query.chargePersonNo = this.handleMultiple2Single(query.chargePerson, 'personNo');
        query.customerNo = this.handleMultiple2Single(query.customer, 'partnerCode');
        delete query.operaterList;
        delete query.chargePerson;
        delete query.customer;
        return filterEmpty(query);
      },
      handleValueToNumber(query) {
        const numberNameList = [
          'projectUsageQuota',
          'projectReceivableQuota',
          'projectIncomePoint',
          'projectAccountingPeriod',
          'monthlySupply',
          'operatingRevenueTarget',
          'collectionCycle',
          'winBidAmount',
        ];
        for (let i = 0; i < numberNameList.length; i++) {
          const element = numberNameList[i];
          const startName = element + 'Start';
          const endName = element + 'End';
          if (Object.prototype.hasOwnProperty.call(query, startName) && query[startName]) {
            query[startName] = Number(query[startName]);
          }
          if (Object.prototype.hasOwnProperty.call(query, endName) && query[endName]) {
            query[endName] = Number(query[endName]);
          }
        }
        return query;
      },
      handleMultiple2Single(multipleSelection, id) {
        let selectList = multipleSelection ? multipleSelection : [];
        if (selectList.length > 0 && selectList[0]) {
          return selectList[0][id];
        }
        return null;
      },
      //搜索区域控制切换事件
      changeContract() {},
      //排序
      sortChangeEvent({ property, order }) {
        if (order) {
          this.sortParams = [
            {
              asc: order === 'asc',
              column: toLine(property),
            },
          ];
          // }
        } else {
          this.sortParams = null;
        }
        this.getData();
      },
      //获取部门
      async getDepartment() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.userInfo.userInfo.companyCode,
        };
        const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        this.departmentList = selectStatus.data.data.personDepartmentInfo;
        this.departmentList.forEach((item) => {
          item.value = item.personDepartmentCode;
          item.label = item.personDepartmentName;
        });
      },
      // 获取公司数据
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      // 列表双击
      dblclickEvent(type) {
        const path = {
          path: '/projectInitiation/projectCreate',
          name: 'projectCreate',
          meta: {
            keepAlive: false,
            title: '编辑项目立项',
          },
          query: {
            id: type.row.id,
            isEdit: false,
            isCreate: false,
            isView: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //删除项目
      delete() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: '请选择1条数据',
            type: 'error',
          });
          return;
        }
        //可删除条件
        let isDelete = true;
        if (
          this.multipleSelection[0].projectInitiationStatus != 'PIS01' &&
          this.multipleSelection[0].projectInitiationStatus != 'PIS03'
        ) {
          isDelete = false;
        }
        if (!isDelete) {
          this.$message({
            showClose: true,
            message: '请选择已保存或已驳回项目',
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            let id = this.multipleSelection[0].id;
            this.loading.startLoading();
            this.$axios
              .post(ProjectApi.DELETE_PROJECT, {
                id: Number(id),
              })
              .then((res) => {
                this.load = false;
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      batchSubmit(value) {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择已保存或已驳回的项目进行提交',
            type: 'error',
          });
          return;
        }
        //只有已保存和已驳回的才可以提交
        let isSubmit = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            this.multipleSelection[i].projectInitiationStatus != 'PIS01' &&
            this.multipleSelection[i].projectInitiationStatus != 'PIS03'
          ) {
            isSubmit = false;
            break;
          }
        }
        if (!isSubmit) {
          this.$message({
            showClose: true,
            message: '请选择已保存或已驳回的项目',
            type: 'error',
          });
          return;
        }
        let ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(Number(item.id));
        });
        this.loading.startLoading();
        this.$axios
          .post(ProjectApi.SUBMIT_APROVER, { ids, oaId: this.userInfo.userInfo.oaId })
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.searchBtnClick();
            } else {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  value.cancelValidate = true;
                  this.batchSubmit(value);
                  this.searchBtnClick();
                },
                callback2: () => {
                  this.searchBtnClick();
                },
              });
            }
          });
      },
      closeHandle() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据',
            type: 'error',
          });
          return;
        }
        if (
          !this.multipleSelection[0].projectInitiationStatus ||
          (this.multipleSelection[0].projectInitiationStatus != 'PIS04' &&
            this.multipleSelection[0].projectInitiationStatus != 'PIS05')
        ) {
          this.$message({
            showClose: true,
            message: '请选择已生效或执行中的项目',
            type: 'error',
          });
          return;
        }
        if (this.load) return;
        this.loading.startLoading();
        let id = this.multipleSelection[0].id;
        this.load = true;
        this.$axios
          .post(ProjectApi.CLOSE_PROJECT, {
            id: Number(id),
          })
          .then((res) => {
            this.load = false;
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.searchBtnClick();
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      handleExportDictValueToName(params) {
        const obj = JSON.parse(JSON.stringify(params));
        const dictValueMap = [
          {
            key: 'businessType',
            dictName: 'PROJECT_INITIATION_BUSINESS_TYPE',
          },
          {
            key: 'projectInitiationStatus',
            dictName: 'PROJECT_INITIATION_STATUS',
          },
          {
            key: 'bidStatus',
            dictName: 'PROJECT_INITIATION_BID_STATUS',
          },
          {
            key: 'enterpriseType',
            dictName: 'enterprise_type',
          },
          {
            key: 'subjectMatter',
            dictName: 'PROJECT_INITIATION_SUBJECT_MATTER',
          },
          {
            key: 'paymentMethod',
            dictName: 'payment_method',
          },
        ];
        for (let i = 0; i < dictValueMap.length; i++) {
          const element = dictValueMap[i];
          if (Object.prototype.hasOwnProperty.call(obj, element.key)) {
            obj[element.key] = this.dictListMap[element.dictName].find(
              (v) => v.value == obj[element.key]
            )?.label;
          }
        }
        return obj;
      },
      // 导出文件
      handleExportProject() {
        const ids = this.selectList.map((item) => item.id);
        if (ids.length < 1) {
          this.$message({
            showClose: true,
            message: '请选择导出的数据',
            type: 'error',
          });
          return;
        }
        const query = this.getQueryData();
        const params = filterEmpty(query);
        this.loading.startLoading();
        // 获取数据
        this.$axios.post(ProjectApi.NEW_EXPORT_PROJECT, { ...params, ids }).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            window.open(res.data.data, '_blank');
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      finishOpenDialogHandle() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据',
            type: 'error',
          });
          return;
        }
        if (
          !this.multipleSelection[0].projectInitiationStatus ||
          (this.multipleSelection[0].projectInitiationStatus != 'PIS04' &&
            this.multipleSelection[0].projectInitiationStatus != 'PIS05') ||
          this.multipleSelection[0].winBidResult
        ) {
          this.$message({
            showClose: true,
            message: '请选择已生效或执行中且招标状态为空的项目',
            type: 'error',
          });
          return;
        }
        this.projectFinishId = this.multipleSelection[0].id;
        this.isExecuted = this.multipleSelection[0].projectInitiationStatus === 'PIS05'; //已生效
        this.dialogVisible = true;
      },
      // 撤销
      async withdrawHandler() {
        if (this.multipleSelection.length < 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据',
            type: 'error',
          });
          return;
        }
        const allProjectInitiationStatus = this.multipleSelection.map(
          (item) => item.projectInitiationStatus
        );
        if (!allProjectInitiationStatus.every((item) => ['PIS04', 'PIS05'].includes(item))) {
          this.$message({
            showClose: true,
            message: '请选择已生效或执行中的项目',
            type: 'error',
          });
          return;
        }
        const ids = this.multipleSelection.map((item) => +item.id);
        const { data } = await this.$axios.post(ProjectApi.WITHDRAW, ids);
        if (data.code == 0) {
          this.$message.success('撤销成功');
          // 刷新列表
          this.getData();
        } else {
          this.$message.error(data.msg);
        }
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type, '点击');
        if (type == 'add') {
          const path = {
            path: '/projectInitiation/projectCreate',
            name: 'projectCreate',
            meta: {
              keepAlive: false,
              title: '新建项目立项',
            },
            query: {
              type: this.radio,
              isEdit: false,
              isCreate: true,
              isView: false,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'finish') {
          this.finishOpenDialogHandle();
        } else if (type == 'close') {
          this.closeHandle();
        } else if (type == 'export') {
          this.handleExportProject();
        } else if (type == 'submit') {
          this.batchSubmit();
        } else if (type == 'withdrawHandler') {
          this.withdrawHandler();
        } else if (type == 'withdrawApprovalHandler') {
          // 撤回审批
          if (this.multipleSelection.length == 0) {
            this.$message({
              showClose: true,
              message: '请选择提交',
              type: 'error',
            });
            return;
          }
          if (this.multipleSelection.some((item) => item.projectInitiationStatus != 'PIS02')) {
            this.$message.error('只有审批中才可以撤回审批');
            return;
          }
          const idList = this.multipleSelection.map((item) => item.id);
          console.log(idList);
          this.loading.startLoading();
          this.$axios
            .post('/sales/projectInitiation/batchWithdrawProjectInitiation', {
              ids: idList,
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              this.loading.endLoading();
              const { code, msg } = res.data;
              if (code == 0) {
                this.$message.success('撤回成功');
                this.resetBtnClick();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              this.loading.endLoading();
            });
        } else if (type == 'editOperationApprover') {
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据',
              type: 'error',
            });
            return;
          }
          const path = {
            path: '/projectInitiation/projectCreate',
            name: 'projectCreate',
            meta: {
              keepAlive: true,
              title: '编辑项目立项',
            },
            query: {
              id: this.multipleSelection[0].id,
              isCreate: false,
              isEdit: false,
              isView: true,
              opreationType: 'editApprover',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
    },
  };
</script>
